export { default, links, meta } from "/home/flare/repos/jsonhero-web/app/routes/privacy.mdx";